import React from 'react'

const TrustBox = () => {
    const ref = React.useRef(null)
    React.useEffect(() => {
        // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
        // If it's not, it means the script you pasted into <head /> isn't loaded  just yet.
        // When it is, it will automatically load the TrustBox.
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(ref.current, true)
        }
    }, [])

    return (
        <div
            ref={ref} // We need a reference to this element to load the TrustBox in the effect.
            className='trustpilot-widget' // Renamed this to className.
            data-locale='en-AU'
            data-template-id='54ad5defc6454f065c28af8b'
            data-businessunit-id='58dc83630000ff00059f7d50'
            data-style-height='240px'
            data-style-width='100%'
            data-theme='light'
            data-tags='SelectedReview'
            data-review-languages='en'
        >
            <a href='https://www.trustpilot.com/review/exetel.com.au' target='_blank' rel='noopener noreferrer'> Trustpilot</a>
        </div>
    )
}

export default TrustBox



// WEBPACK FOOTER //
// ./resources/js/components/TrustBox.js